import { OndigoNS } from '../../modules/main.js';
import videojs from 'video.js';

(function () {
    "use strict";
    window.youtubeVideoDOM = {};

    OndigoNS.VideoJS = (function () {

        var activePlayers = [],
            playerDOMArray = [],
            playerIds = [],

            initializeVideo = function ($player) {
                var id = $('.video-js', $player).attr('id'),
                    src = $player.data('video-src'),
                    type = $player.data('video-network'),
                    init = $player.data('init') === 1,
                    isPlaylist = $player.data('playlist') === 1,
                    config = {};

                if (type === 'youtube') {
                    config = {"techOrder": ["youtube"], "sources": [{ "type": "video/youtube", "src": src }] };
                }

                addVideoDOM(id, config, $player);

                if (init) {
                    if (isPlaylist && window.location.hash.indexOf('!') === -1) {
                        initPlayerDOMById(id, false);
                    } else {
                        initPlayerById(id, getDOMObjectById(id), false);
                    }
                }
            },

            addVideoDOM = function (id, config, $player) {
                var domObject = {};
                domObject.config = config;
                domObject.html = $player.parent().html();
                domObject.$container = $player.parent();
                domObject.originalId = id;
                playerDOMArray[id] = domObject;
            },

            initPlayerById = function (id, domObject, autoplay) {
                var $videoContent = $('#' + id).closest('.videoContent');

                if($videoContent.data('video-network') === 'youtube') {

                    if(window.yt_allowed) {
                        $('.activate-usercentrics-youtube', $videoContent).hide();
                        initVideoJsIfYoutubeAllowedOrNormalFile(id, domObject, autoplay);
                    } else {
                        $('.activate-usercentrics-youtube', $videoContent).show();
                    }
                } else {
                    initVideoJsIfYoutubeAllowedOrNormalFile(id, domObject, autoplay);
                }
            },

            initVideoJsIfYoutubeAllowedOrNormalFile = function (id, domObject, autoplay) {
                if(!window.youtubeVideoDOM[id] && $('#' + id).closest('.videoContent').data('video-network') === 'youtube') {
                    window.youtubeVideoDOM[id] = domObject.html;

                    $('#' + id).closest('.videoContent').data('youtube-initialized', '1');
                }

                var myPlayer = videojs(id, domObject.config);

                if (!OndigoNS.Utils.videoPlaysInline()) {
                    $('.vjs-control-bar').css('display', 'none');
                }

                myPlayer.ready(function () {

                    OndigoNS.VideoJS.addPlayer(this, domObject.originalId);

                    var ap = autoplay,
                        player = this;

                    setTimeout(function () {
                        if (ap && !OndigoNS.Utils.isIOSDevice()) {
                            try {
                                myPlayer.bigPlayButton.hide();
                                player.play();
                            } catch (e) {

                            }
                        }
                    }, 200);
                });
            },

            getDOMObjectById = function (id) {
                return playerDOMArray[id];
            },

            initPlayerDOMById = function (id, autoplay, callObject, removeHidden) {
                var domObject = getDOMObjectById(id),
                    ts = 'vid' + Math.round((new Date()).getTime() / 1000);

                domObject.$container.empty();
                domObject.$container.append(domObject.html);

                $('#' + id).attr('id', ts);

                if (removeHidden) {
                    $('#' + ts).removeClass('hidden');
                }

                playerIds[id] = ts;

                OndigoNS.VideoJS.initPlayerById(ts, domObject, autoplay);
            },

            addPlayer = function (player) {
                activePlayers.push(player);

                player.on('play', function (e) {
                    e.preventDefault();

                    OndigoNS.VideoJS.setHash(player.id());
                    OndigoNS.VideoJS.scrollToActiveVideo($(this.contentEl()));

                    if (!OndigoNS.Utils.hasTouchscreen()) {
                        var i,
                            activePlayer;

                        for (i = 0; i < activePlayers.length; i++) {
                            activePlayer = activePlayers[i];
                            if (activePlayer.id() !== player.id()) {
                                try {
                                    activePlayer.pause();
                                } catch (error) {

                                }
                            }
                        }
                    }
                });
            },

            setHash = function (originalId) {
                window.location.hash = '!' + originalId;
            },

            pauseVideo = function () {
                $.each(activePlayers, function() {
                    this.pause();
                });
            },

            startVideo = function () {
                $.each(activePlayers, function() {
                    this.play();
                });
            },

            getContainerById = function (id) {
                var domObject = getDOMObjectById(id);
                if (domObject) {
                    return domObject.$container;
                } else {
                    return null;
                }
            },

            getPlayerById = function (id) {
                return playerIds[id];
            },

            scrollToActiveVideo = function ($contentElement) {
                if ($contentElement && !OndigoNS.Utils.isElementInViewport($contentElement)) {
                    $("html, body").animate({scrollTop: $contentElement.offset().top});
                }
            },

            jumpToActiveHash = function () {
                if (window.location.hash && window.location.hash.indexOf('#!') !== -1) {
                    var id = window.location.hash.replace(/\D/g, ''),
                        $player = $('.videoContent[data-video-id=' + id + ']');

                    scrollToActiveVideo($player);
                }
            },

            parseYoutubeUrl = function (url) {
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
                var match = url.match(regExp);
                if (match && match[7].length === 11) {
                    return match[7];
                }
            },

            reloadPlayer = function ($container) {
                var $videoContent = $('.videoContent', $container),
                    videoId;

                if ($videoContent.length && OndigoNS.Utils.isIOSDevice()) {
                    videoId = 'v' + $videoContent.data('video-id');
                    initPlayerDOMById(videoId, false);
                }
            },

            setVideoJsSWF = function () {
                videojs.options['flash']['swf'] = location.protocol + "//" + location.host + '/swf/video-js.swf';
            };

        return {
            initializeVideo: initializeVideo,
            addPlayer: addPlayer,
            scrollToActiveVideo: scrollToActiveVideo,
            jumpToActiveHash: jumpToActiveHash,
            initPlayerById : initPlayerById,
            initPlayerDOMById : initPlayerDOMById,
            getContainerById : getContainerById,
            addVideoDOM : addVideoDOM,
            parseYoutubeUrl : parseYoutubeUrl,
            getPlayerById : getPlayerById,
            reloadPlayer : reloadPlayer,
            setHash : setHash,
            startVideo : startVideo,
            pauseVideo : pauseVideo,
            setVideoJsSWF : setVideoJsSWF
        };
    }());
}());


(function ($) {
    'use strict';

    // class definition
    OndigoNS.VideojsCustom = function (element) {
        this.$videoContent = $(element);
        OndigoNS.VideoJS.initializeVideo(this.$videoContent);
    };

    // plugin definition
    $.fn.videojsCustom = function () {
        return new OndigoNS.VideojsCustom(this);
    };
    $.fn.videojsCustom.Constructor = OndigoNS.VideojsCustom;

}(window.jQuery));


$(document).ready(function (e) {
    'use strict';

    var $videoContent = $('.videoContent');

    if ($videoContent.length) {

        $.each($videoContent, function () {
            if($(this).data('video-network') !== 'youtube') {
                $(this).videojsCustom();
            }
        });
    }

    $(document).bind('youtubeApiLoaded', function(e) {

        if ($('.videoContent').length) {

            $.each($('.videoContent'), function () {

                if($(this).data('video-network') === 'youtube' && $(this).data('youtube-initialized') !== '1') {
                    $(this).videojsCustom();
                }
            });
        }
    });
});